// Memory-only access-token holder — the single runtime source of truth.
//
// Access tokens exist only in memory. Reload/session recovery uses the
// HttpOnly refresh cookie; no bearer credential is written to localStorage.
//
// This module has no imports so it can be used by both the axios interceptor
// (api/config.ts) and the auth store without creating an import cycle.

let tokenCache: string | null = null;
let authGeneration = 0;

export const tokenStore = {
  get(): string | null {
    return tokenCache;
  },
  set(token: string | null): void {
    authGeneration += 1;
    tokenCache = token;
  },
  clear(): void {
    authGeneration += 1;
    tokenCache = null;
  },
  generation(): number {
    return authGeneration;
  },
};
